import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { AddressComponent } from 'premier-capability-policyjob-react';
import styles from "../../../../SpecialtyPersonalStyles.module.scss"
import metadata from './PropertyDetailsComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function PropertyDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PropertyDetailsComponent');
    const [isEditAddress, setIsEditAddress] = useState(false)
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const [actAddress, setActAddress] = useState(null)

    if (_.isUndefined(modelVM.accountLocFie.value)) {
        const model = { country: 'CA' }
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
    }

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if (value === 'new' && changedPath === 'actAdrsPublicID') {
                setIsEditAddress(true)
            }

            if (changedPath === 'yeaBuiFie') {
                _.set(modelVM, 'rooYeaLasUpdFie.value', value)
                _.set(modelVM, 'yealasupdFie7.value', value)
                _.set(modelVM, 'yealasupdFie.value', value)
                _.set(modelVM, 'eleSysYeaLasUpdFie.value', value)
                _.set(modelVM, 'pluLasUpdFie.value', value)
            }

            _.set(submissionVM, `${fullPath}`, value);

            if (changedPath === 'disfroFirHydFie' || changedPath === 'distoFirHalFie' || changedPath === 'fusgraFie') {
                const fusgraFie = _.get(modelVM, 'fusgraFie.value')
                const disfroFirHydFie = _.get(modelVM, 'disfroFirHydFie.value')
                const distoFirHalFie = _.get(modelVM, 'distoFirHalFie.value')
                const fusGrade1 = ['1', '2', '3A' ]
                const fusGrade2 = [ '3B', '3BS', '3BL' ]
                const fuseGrade3 = [ '4', '5' ]
                let ProClaFie = ''

                if (_.isUndefined(fusgraFie)) {
                    if (disfroFirHydFie.code === 'Wit300m' && distoFirHalFie.code === 'Wit8km') {
                        ProClaFie = 'Pro'
                    } else if (disfroFirHydFie.code === 'Wit300m' && distoFirHalFie.code === 'Ove8km') {
                        ProClaFie = 'Unp'
                    } else if (disfroFirHydFie.code === 'Ove300m' && distoFirHalFie.code === 'Wit8km') {
                        ProClaFie = 'Sem'
                    } else if (disfroFirHydFie.code === 'Ove300m' && distoFirHalFie.code === 'Ove8km') {
                        ProClaFie = 'Unp'
                    }
                } else if (fusGrade1.includes(fusgraFie.code)) {
                    ProClaFie = 'Pro'
                } else if (fusGrade2.includes(fusgraFie.code)) {
                    ProClaFie = 'Sem'
                } else if (fuseGrade3.includes(fusgraFie.code)) {
                    ProClaFie = 'Unp'
                }

                _.set(submissionVM, `${pathUpdated}.value.proClaFie`, ProClaFie);
            }

            updateWizardData(submissionVM);
        },
        [modelVM, pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountLocFie.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);


    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const setIsEditButton = () => {
        setActAddress(modelVM.accountLocFie.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        } else {

            modelVM.accountLocFie.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountLocFie.value, 'accountLocFie')
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountLocFie,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        },
        ifothpleexpFie2: {
            visible: _.get(modelVM, 'conFie.value.code') === 'Other'
        },
        ifothpleexpFie: {
            visible: _.get(modelVM, 'cerFie.value.code') === 'Other'
        },
        ifOthExpFie9: {
            visible: _.get(modelVM, 'priHeaFie2.value.code') === 'Other'
        },
        priHeaFueTypFie: {
            visible: _.get(modelVM, 'priHeaFie2.value.code') !== undefined && _.get(modelVM, 'priHeaFie2.value.code') !== 'Non'
        },
        ifOthExpFie6: {
            visible: _.get(modelVM, 'priHeaFie2.value.code') !== undefined
                && _.get(modelVM, 'priHeaFie2.value.code') !== 'Non' && _.get(modelVM, 'priHeaFueTypFie.value.code') === 'Oth'
        },
        yealasupdFie7: {
            visible: _.get(modelVM, 'priHeaFie2.value.code') !== undefined && _.get(modelVM, 'priHeaFie2.value.code') !== 'Non'
        },
        auxHeaFueTypFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code') !== undefined && _.get(modelVM, 'auxHeaFie.value.code') !== 'None'
        },
        yealasupdFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code') !== undefined && _.get(modelVM, 'auxHeaFie.value.code') !== 'None'
        },
        ifOthExpFie7: {
            visible: _.get(modelVM, 'auxHeaFie.value.code') !== undefined
                && _.get(modelVM, 'auxHeaFie.value.code') !== 'None' && _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Oth'
        },
        ifAppAnnCorofWooBuBurFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code') === 'ComWitWoo' || _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Wood'
        },
        ifAppAnnBagofPelBuBurFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code') === 'ComWitWoo' || _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Wood'
        },
        oilTankContainer: {
            visible: _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Oil' || _.get(modelVM, 'priHeaFueTypFie.value.code') === 'Oil'
        },
        ifOthExpFieES: {
            visible: !_.isUndefined(modelVM.othFie.value) && modelVM.othFie.value
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            AddressComponent
        },
        resolveClassNameMap: styles
    };


    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PropertyDetailsComponent.propTypes = wizardProps;
export default withRouter(PropertyDetailsComponent);
